import { render, staticRenderFns } from "./TinyViewer.vue?vue&type=template&id=4ba4cc30"
import script from "./TinyViewer.vue?vue&type=script&lang=js"
export * from "./TinyViewer.vue?vue&type=script&lang=js"
import style0 from "./TinyViewer.vue?vue&type=style&index=0&id=4ba4cc30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports